import React from "react";
import CovidProtection from "../../../components/desktop/covid-protection";
import { Helmet } from "react-helmet-async";
import withLayout from "../../../components/desktop/layout/component";
import { appUrl } from "../../../constants/url-constants";

const Cars24Protect = () => {
    return (<React.Fragment>
        <Helmet>
            <title>Cars24 | Sell your car the safer way</title>
            <link href={`${appUrl()}/cars24-protect/`} rel="canonical" />
        </Helmet>
        <CovidProtection />
    </React.Fragment>);
};

export default withLayout(Cars24Protect);
